/**
 * AI 分析加载状态：展示流式生成动画与停止入口。
 */
import React, { memo } from 'react';
import { useIntl } from 'umi';
import { Button, LoadingTip } from 'tea-component';
import CopilotAnswerLoading from '@/pages/aigc/pages/Agent/Copilot/components/AnswerLoading';
import type { IAiStatusLoadingProps } from '../../types';
import './shared.scss';

const AiStatusLoading: React.FC<IAiStatusLoadingProps> = (props) => {
  const { onStopClick } = props;
  const { formatMessage } = useIntl();

  return (
    <div className="dbl-ai-status dbl-ai-status--loading">
      <CopilotAnswerLoading className="dbl-ai-status__loading" />
      <div className="dbl-ai-status__loading-row">
        <LoadingTip loadingText={formatMessage({ id: 'dbl_ai_analysis_generating' })} />
        <Button
          type="link"
          className="dbl-ai-status__action"
          onClick={onStopClick}
        >
          {formatMessage({ id: 'dbl_common_stop' })}
        </Button>
      </div>
    </div>
  );
};

export default memo(AiStatusLoading);
